import {Customer} from "../../../model/customer/customer";
import {Injectable} from "@angular/core";
import {CustomerComponent} from "../../../crystal-clear/customer/customer/customer.component";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {Trader} from "../../../model/customer/trader";
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {BankAccount} from "../../../model/customer/bank-account";
import {BrokerageTable} from "../../../model/customer/brokerage-table";
import {ReportProfile} from "../../../model/archive/report-profile";
import { FieldsService } from "../../common/fields-service";
import {CommonFieldService} from "../../common/common-field.service";

@Injectable({
  providedIn: 'root'
})
export class CustomerCustomerDataLoadingService {

  traders: FieldRecord<Trader>[] = [];

  countries: FieldRecord<any>[] = [];

  languages: FieldRecord<any>[] = [];

  owners: FieldRecord<any>[] = [];

  currencies: FieldRecord<string>[] = [];

  bankAccounts: FieldRecord<BankAccount>[] = [];

  brokerageTables: FieldRecord<BrokerageTable>[] = [];

  brokerageTablesVisibles: FieldRecord<BrokerageTable>[] = [];

  invoices: FieldRecord<ReportProfile>[] = [];

  constructor(private readonly commonFieldService: CommonFieldService,
              private readonly fieldsService: FieldsService) {
  }

  loadData(component: CustomerComponent) {
    this.fieldsService.loadField(this.countries, () => this.commonFieldService.getCountries(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.languages, () => this.commonFieldService.getLanguages(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.owners, () => this.commonFieldService.getOwners(FieldRequest.DEFAULT()), component.tracker, (records) => {
      if (records?.length) {
        component.newRecord.owner = records[0].text;
        if (component.formRecord) {
          component.formRecord.owner = records[0].text;
          this.refreshBrokerageTables(component.formRecord);
        }
      }
    });
    this.fieldsService.loadField(this.currencies, () => this.commonFieldService.getCurrencies(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.bankAccounts, () => this.commonFieldService.getBankAccounts(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.brokerageTables, () => this.commonFieldService.getBrokerageTables(FieldRequest.DEFAULT()), component.tracker);
    this.fieldsService.loadField(this.invoices, () => this.commonFieldService.getInvoices(FieldRequest.DEFAULT()), component.tracker);

    this.loadTraders(component);
  }

  loadTraders(component: CustomerComponent){
    this.fieldsService.loadField(this.traders, () => this.commonFieldService.getTraders(FieldRequest.DEFAULT()), component.tracker);
  }


  public refreshBrokerageTables(record: Customer) {
    this.brokerageTablesVisibles = this.brokerageTables.filter(value => value.value.ownerCode === record.owner)
      .filter((value, index, self) =>
        index === self.findIndex((t) => t.value.brokerageTableName === value.value.brokerageTableName)
      );
  }
}
